import { getLocalePrefix } from '@modules/localization/implementations/translationResourceHelpers';
import { Locale } from '@rbx/intl';

const getOpenSourceEditLink = (
  isEmployee: boolean,
  locale: Locale,
  contentDirFilePath?: string,
) => {
  const repoUrl = isEmployee
    ? `https://github.com/Roblox/creator-docs-staging`
    : `https://github.com/${process.env.openSourceRepo}`;
  const branch = isEmployee ? 'staging' : process.env.openSourceBranch;

  // if can't fetch file path, show homepage of repo
  // (previewing the file structure)
  if (!contentDirFilePath) {
    return repoUrl;
  }

  return `${repoUrl}/blob/${branch}/content/${getLocalePrefix(locale)}${contentDirFilePath}`;
};

export default getOpenSourceEditLink;
